export const MARKET_SELECTOR = "market"
export const LANGUAGE_SELECTOR = "language"
export const USER_MENU_OPTIONS = {
	ADMINISTRATION: "userManagement",
	CONFIGURATION: "configuration",
	LOGOUT: "logout",
}
